var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCardFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.657 10A7.492 7.492 0 0022 12.342V19a1 1 0 01-1 1H3a1 1 0 01-1-1v-9h9.657zM6 15a1 1 0 100 2h4l.102-.005a1 1 0 000-1.99L10 15H6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0a6 6 0 110 12 6 6 0 010-12zm0 2.75a.586.586 0 00-.596.596v2.058h-2.058a.59.59 0 00-.331.097l-.092.075A.585.585 0 0014.75 6c0 .161.057.308.173.424v-.001a.583.583 0 00.423.173h2.058v2.058c0 .161.057.308.172.423l.093.076c.098.065.21.097.331.097a.586.586 0 00.424-.173h-.001a.583.583 0 00.173-.423V6.596h2.058c.161 0 .308-.057.423-.172l.076-.093A.59.59 0 0021.25 6a.586.586 0 00-.596-.596h-2.058V3.346a.59.59 0 00-.097-.331l-.075-.092A.585.585 0 0018 2.75z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.771 4a7.505 7.505 0 000 4H2V5a1 1 0 011-1h7.771z",
    fill: "currentColor"
  })));
}
SvgAddCardFilled.displayName = 'AddCardFilled';
export default SvgAddCardFilled;